<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/personPerformanceList' }">人员绩效</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <div>
                        <el-button size="small" plain @click="insert">新增</el-button>
                        <el-button size="small" plain @click="update">编辑</el-button>
                        <el-button size="small" plain @click="del">删除</el-button>
                        <draggableDetail :draggable="{ data_name: 'person_performance' }" @isErrshow="reload"></draggableDetail>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div class="read_only read_only_link" v-if="in_array(item.prop, ['person_name'])">
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="绩效人员" name="2">
                    <vPerformancePersonComponent v-if="flag" :postList="postList"></vPerformancePersonComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="人员绩效审批" name="3">
                    <vPersonPerformaneConfirmComponent v-if="flag1" :postList="postList1"></vPersonPerformaneConfirmComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="人员绩效调整" name="4">
                    <vPersonPerformaneLineComponent v-if="flag1" :postList="postList1"></vPersonPerformaneLineComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import draggableDetail from '../../../common/DrawerDetail.vue';
import vPerformancePersonComponent from '@/components/page/listComponent/basicdata/performance/performancePersonComponent.vue';
import vPersonPerformaneConfirmComponent from '@/components/page/listComponent/basicdata/performance/personPerformanceConfirmComponent.vue';
import vPersonPerformaneLineComponent from '@/components/page/listComponent/basicdata/performance/personPerformanceLineComponent.vue';
export default {
    inject: ['reload'],
    name: 'personPerformanceDetail',
    components: {
        draggableDetail,
        vPerformancePersonComponent,
        vPersonPerformaneConfirmComponent,
        vPersonPerformaneLineComponent
    },
    data() {
        return {
            colData: [],
            activeNames: ['1', '2', '3', '4'],
            data: {},
            queryParams: {},
            headerTitle: '人员绩效详情',
            flag: false,
            postList: {
                params: {
                    person_code: '',
                    period_code: ''
                }
            },
            flag1: false,
            postList1: {
                params: {
                    person_performance_id: ''
                }
            }
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.id = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.flag = false;
        this.flag1 = false;
        this.$nextTick(() => {
            this.getData(); //获取详情
        });
    },
    methods: {
        in_array,
        toDetail(prop) {
            if (in_array(prop, ['person_name']) && this.data.person_rid) {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: this.data.person_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.id = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).person_performance;
            processColumnDataToRowNew(colData, this);
        },
        //详情
        getData() {
            this.$api
                .personPerformanceDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.id;
                    this.flag = true;
                    this.postList.params.person_code = res.data.person_code;
                    this.postList.params.period_code = res.data.period_code;
                    this.flag1 = true;
                    this.postList1.params.person_performance_id = res.data.id;
                })
                .catch((error) => {});
        },
        //新增
        insert() {
            this.$router.push({
                path: 'personPerformanceEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //编辑
        update() {
            this.$router.push({
                path: 'personPerformanceEdit',
                query: {
                    type: 'update',
                    id: this.data.id
                }
            });
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'personPerformanceDelete', this.data.id, 'personPerformanceList');
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>